module.exports = __webpack_public_path__ + "static/img/bg-highlights-5.e71f5635.png";